import type { Accessor } from "solid-js";
import type { AbstractPowerSyncDatabase } from "@powersync/common";
import type { PowerSyncDrizzleDB } from "@tendly/powersync";
import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { useSession } from "@/lib/auth";

export interface TendlyDeps {
  db: Accessor<AbstractPowerSyncDatabase | null>;
  drizzle: Accessor<PowerSyncDrizzleDB | null>;
  userId: Accessor<string | undefined>;
}

/** Common dependencies of all Tendly domain hooks/views. */
export function useTendlyDeps(): TendlyDeps {
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();
  const session = useSession();
  return { db: () => db(), drizzle, userId: () => session.userId() || undefined };
}
